import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bdf237e0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "guideIndex"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 0,
  class: "year"
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_list = _resolveComponent("van-list");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_list, {
    loading: $data.loading,
    "onUpdate:loading": _cache[0] || (_cache[0] = $event => $data.loading = $event),
    finished: $data.finished,
    "finished-text": $data.finishedtext,
    onLoad: $options.getList
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, item => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(`${item.year ? 'yearList' : 'list'}`),
        onClick: $event => $options.toDetail(item)
      }, [item.year ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(item.year), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("img", {
        src: item.image[0]
      }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1)]))], 10, _hoisted_2);
    }), 256))]),
    _: 1
  }, 8, ["loading", "finished", "finished-text", "onLoad"])]);
}